import React from 'react';
import SuperuserPrimeReportsPanel from './SuperuserPrimeReportsPanel';

const SuperuserPrimeReportsPage: React.FC = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-slate-900 tracking-tight">Prime Reports</h1>
        <p className="text-sm text-slate-500 mt-1">
          React management console for creating, editing, and deactivating prime reports.
        </p>
      </div>
      <SuperuserPrimeReportsPanel />
    </div>
  );
};

export default SuperuserPrimeReportsPage;
